export default "__VITE_ASSET__4cb30805__"